import React from "react";
import ContactFormEnquery from "./ContactFormEnquery";

export default function ContactSectionHome() {
  return (
    <>
      <section className="contact-section-3 fix section-padding ">
        <div className="container">
          <div className="contact-wrapper-10">
            <div className="section-title text-center mb-0">
              {/* <h5 className="wow fadeInUp">
                <i className="fa fa-angle-double-left" aria-hidden="true"></i> Keep
                In Touch{" "}
                <i className="fa fa-angle-double-right" aria-hidden="true"></i>
              </h5> */}
              <h2 className="wow fadeInUp" data-wow-delay=".3s">
                Get in Touch with Our Team
              </h2>
            </div>
            <ContactFormEnquery />
          </div>
        </div>
      </section>
    </>
  );
}
